module.exports = function findFeaturedImage(relationships) {
	let media_field_name = relationships
		? [
				"field_image",
				"field_featured_image",
				"field_banner_media_image",
				"field_media_image",
				"field_profile_image",
		  ].find(
				(img_field_key) =>
					relationships[img_field_key] && relationships[img_field_key].data
		  )
		: null;
	let media_rel = media_field_name ? relationships[media_field_name].data : null;
	return media_rel;
};
